import * as styles from "./dashboardRow.module.scss";

export const DashboardRow = ({
  main,
  secondary,
  secondaryWidth = 360,
  gap = 16,
}) => {
  return (
    <div className={styles.dashboardRow} style={{ gap }}>
      <div className={styles.dashboardRow__colMain}>{main}</div>
      <div
        className={styles.dashboardRow__colSecondary}
        style={{
          flex: `0 0 ${secondaryWidth}px`,
          maxWidth: `${secondaryWidth}px`,
        }}
      >
        {secondary}
      </div>
    </div>
  );
};
